import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function MobilePhoneIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M9.714 2v.84c0 .336 0 .504-.062.632a.6.6 0 0 1-.25.263C9.28 3.8 9.12 3.8 8.8 3.8H7.2c-.32 0-.48 0-.602-.065a.6.6 0 0 1-.25-.263c-.062-.128-.062-.296-.062-.632V2m-.457 12h4.342c.64 0 .96 0 1.205-.13.215-.116.39-.3.5-.525.124-.257.124-.593.124-1.265V3.92c0-.672 0-1.008-.125-1.265a1.17 1.17 0 0 0-.499-.524C11.132 2 10.812 2 10.171 2H5.83c-.64 0-.96 0-1.205.13-.215.116-.39.3-.5.525C4 2.912 4 3.248 4 3.92v8.16c0 .672 0 1.008.125 1.265.11.226.284.41.499.524.244.131.565.131 1.205.131" /></svg>
  );
}

export default MobilePhoneIcon;
